import React from 'react';

import Pusher from 'pusher-js';
import * as act from 'actions';
import {
  ContentWrapper,
  LeftColumnWrapper,
  RightColumnWrapper,
  PageWrapper,
} from 'components/wrappers/pages';
import {
  pageRequest,
  doneExportRecipe,
  resetLoadingUpload,
  closeCreateRecipesModal,
  resetModalImportRecipe,
  setMessageResponseFailedImportRecipe,
} from 'actions/ingredients/recipes';
import { connect } from 'react-redux';
import ConfirmActionModal from 'components/ConfirmActionModal';
import CreateRecipesModal from 'components/CreateRecipesModal';
import { browserHistory } from 'react-router';
import { isDirty } from 'redux-form';
import { askConfirmAction } from 'actions/confirm-action';
import { push } from 'react-router-redux';
import NoDataAndLoading from 'components/NoDataAndLoading';
import {
  PUSHER_APP_KEY,
  INVENTORY_BUSINESS_PUSHER_CHANNEL,
  INVENTORY_CLONE_OUTLET_PUSHER_EVENT,
} from 'api/constants';
import * as actOutletPage from 'actions/outletPages/list';
import { setUserProperty } from 'actions/userProperties';
import RecipesDetail from './RecipesDetail';
import SaveToAllOutletsModal from './SaveToAllOutletsModal';
import List from './List';
import ActionBar from './ActionBar';
import './Recipes.css';

class Recipes extends React.Component {
  render() {
    const { openRightColumn, showLoadingSpinnerPage, recipes } = this.props;
    return (
      <PageWrapper>
        <ActionBar />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={openRightColumn}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={recipes.length === 0}
              title="No Data To Display"
              description=""
              linkLabel="Create Recipe"
              linkUrl="https://mokaposhelp.zendesk.com/hc/id/articles/115004499493-Cara-Membuat-Resep"
            />
            {!showLoadingSpinnerPage && recipes.length > 0 && <List />}
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={openRightColumn}>
            <RecipesDetail />
          </RightColumnWrapper>
        </ContentWrapper>
        <CreateRecipesModal />
        <ConfirmActionModal />
        <SaveToAllOutletsModal />
      </PageWrapper>
    );
  }

  componentDidMount() {
    const { dispatch, outletId, businessId } = this.props;
    const pusher = new Pusher(PUSHER_APP_KEY, {
      cluster: 'ap1',
      encrypted: true,
    });
    this.channel = pusher.subscribe(`moka-${outletId}-${businessId}-inventory`);
    this.cloneChannel = pusher.subscribe(
      INVENTORY_BUSINESS_PUSHER_CHANNEL(businessId)
    );

    dispatch(pageRequest());
    browserHistory.listenBefore(location => {
      const { isDirtyRecipes, nextAction } = this.props;
      if (isDirtyRecipes && !nextAction) {
        dispatch(askConfirmAction(push(location)));
        return false;
      }
    });
    this.props.dispatch(setUserProperty('ftueImportRecipe', true));
  }

  componentDidUpdate() {
    const { dispatch, idAsyncJob } = this.props;
    if (this.channel) {
      this.channel.unbind();
    }
    this.channel.bind('library/recipe/export', data => {
      if (
        idAsyncJob &&
        data.resource_id &&
        idAsyncJob === data.resource_id &&
        data.type === 'export-done' &&
        data.success
      ) {
        dispatch(doneExportRecipe());
        this._handleSuccessExportErrorList();
        window.location.href = data.url_path;
        dispatch(act.showLoadingSpinner(false));
      } else if (
        idAsyncJob &&
        data.resource_id &&
        idAsyncJob === data.resource_id &&
        !data.success &&
        data.type === 'export-done'
      ) {
        const errorMessage = data.error
          ? // eslint-disable-next-line no-useless-escape
            data.error.replace(/[\'"{}[\]\\\/]/gi, '').split(',')[0]
          : 'Your error data is already wiped out';
        dispatch(
          setMessageResponseFailedImportRecipe({ messages: errorMessage })
        );
        dispatch(act.showLoadingSpinner(false));
      }
    });

    if (this.cloneChannel) {
      this.cloneChannel.unbind();
    }
    this.cloneChannel.bind(INVENTORY_CLONE_OUTLET_PUSHER_EVENT, data => {
      dispatch(actOutletPage.checkCloningOutletOnProgress(data));
    });
  }

  componentWillUnmount() {
    if (this.cloneChannel) {
      this.cloneChannel.unbind();
    }
  }

  _handleSuccessExportErrorList() {
    const { createRecipesForm, dispatch } = this.props;
    dispatch(resetLoadingUpload());
    if (createRecipesForm.isError) {
      dispatch(closeCreateRecipesModal());
      dispatch(resetModalImportRecipe());
    }
  }
}

function mapStateToProps(state) {
  const { idAsyncJob } = state.ingredients.recipes;
  const { showLoadingSpinnerPage } = state.loadingSpinner;
  const {
    openRightColumn,
    recipes,
    showCreateRecipesModal,
    createRecipesForm,
  } = state.ingredients.recipes;
  const { id } = state.moka.user.business;
  const currentOutletId = state.moka.user.outlet_id[0];
  return {
    showCreateRecipesModal,
    createRecipesForm,
    openRightColumn,
    showLoadingSpinnerPage,
    nextAction: state.confirmAction.nextAction,
    isDirtyRecipes: isDirty('recipes')(state),
    businessId: id,
    outletId: currentOutletId,
    recipes,
    idAsyncJob,
  };
}

export default connect(mapStateToProps)(Recipes);
